import { render, staticRenderFns } from "./LeaveTypeLabel.vue?vue&type=template&id=02e05f08"
import script from "./LeaveTypeLabel.vue?vue&type=script&lang=js"
export * from "./LeaveTypeLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports